import Avatar from "~/components/ui/Avatar";
import { sanitizeStoreUrl } from "~/utils/constants";

interface SkuSelectorProps {
  variants: [string, string | undefined][];
}

function SkuSelector({ variants }: SkuSelectorProps) {
  return (
    <>
      {variants.map(([value, link]) => {
        const isNotAvailable = link?.includes("NOT_AVAILABLE");
        const href = sanitizeStoreUrl(link?.split("::").slice(-1)[0]);

        return (
          <li key={value}>
            <a href={isNotAvailable ? undefined : href}>
              <Avatar
                isSelected={link?.split("::")[1] === "SELECTED"}
                variant={isNotAvailable ? "disabled" : "default"}
                content={value}
              />
            </a>
          </li>
        );
      })}
    </>
  );
}

export default SkuSelector;

